// @flow
import EventEmitter from 'events';
import Storage from '../protocol/Storage';

const debug = require('../debug/debug')('wc:video:VideoController');

export type VideoControllerState = {
  volume: number,
  playbackRate: number,
  currentTime: number,
  duration: number,
  muted: boolean,
  playing: boolean,
  frameRate: number
};

const _initialState: VideoControllerState = {
  volume: 0.7,
  playbackRate: 1,
  currentTime: 0,
  duration: 0,
  muted: false,
  playing: true,
  frameRate: 0
};

export default class VideoController extends EventEmitter {
  _volume: number;
  _playbackRate: number;
  _currentTime: number;
  _duration: number;
  _muted: boolean;
  _playing: boolean;
  _frameRate: number;
  _videoStartTimecode: number;

  constructor(initialState: VideoControllerState = _initialState) {
    super();

    this._volume = initialState.volume;
    this._playbackRate = initialState.playbackRate;
    this._currentTime = initialState.currentTime;
    this._duration = initialState.duration;
    this._muted = initialState.muted;
    this._playing = initialState.playing;
    this._frameRate = initialState.frameRate;
    this._videoStartTimecode = 0;
  }

  get volume() {
    return this._volume;
  }

  set volume(volume: number) {
    if (volume === this._volume) {
      return;
    }

    const prevState = this.state;
    this._volume = volume;
    this._emit('change', prevState);
  }

  get playbackRate() {
    return this._playbackRate;
  }

  set playbackRate(playbackRate: number) {
    if (playbackRate === this._playbackRate) {
      return;
    }

    const prevState = this.state;
    this._playbackRate = playbackRate;
    this._emit('change', prevState);
  }

  get currentTime() {
    return this._currentTime;
  }

  setCurrentTime(currentTime: number, emit: boolean = false) {
    if (currentTime === this._currentTime) {
      return;
    }

    const prevState = this.state;
    this._currentTime = currentTime;

    this._emit('change:currentTime', prevState);
    if (emit) {
      this._emit('change', prevState);
    }
    debug('setCurrentTime(currentTime: %s', currentTime);
  }

  get duration() {
    return this._duration;
  }

  set duration(duration: number) {
    if (duration === this._duration) {
      return;
    }

    const prevState = this.state;
    this._duration = duration;
    this._emit('change:duration', prevState);
    this._emit('change', prevState);
  }

  get muted() {
    return this._muted;
  }

  set muted(muted: boolean) {
    if (muted === this._muted) {
      return;
    }

    const prevState = this.state;
    this._muted = muted;
    this._emit('change', prevState);
  }

  get playing() {
    return this._playing;
  }

  set playing(playing: boolean) {
    if (playing === this._playing) {
      return;
    }

    const prevState = this.state;
    this._playing = playing;
    this._emit('change', prevState);
  }

  get frameRate() {
    return this._frameRate;
  }

  set frameRate(value: number) {
    this._frameRate = value;
  }

  setPlaying(playing: boolean, emit: boolean = false) {
    if (playing === this._playing) {
      return;
    }

    const prevState = this.state;
    this._playing = playing;

    this._emit('change:playing', prevState);
    if (emit) {
      this._emit('change', prevState);
    }
  }

  get state(): VideoControllerState {
    return {
      volume: this.volume,
      playbackRate: this.playbackRate,
      currentTime: this.currentTime,
      duration: this.duration,
      muted: this.muted,
      playing: this.playing,
      frameRate: this.frameRate,
      videoStartTimecode: this.videoStartTimecode
    };
  }

  _emit(eventName: string, prevState: VideoControllerState) {
    debug('[_emit()]', eventName, prevState, this.state);
    if (Storage.get('VideoTrace')) {
      console.trace();
    }

    this.emit(eventName, prevState);
  }

  set videoStartTimecode(startTimecode: number) {
    //const prevState = this.state;
    this._videoStartTimecode = startTimecode;
    //  this._emit('change', prevState);
  }

  get videoStartTimecode(): number {
    return this._videoStartTimecode;
  }
}
